import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the pt-PT locale.
 */

export const appI18NPtPT: Record<string, any> = {
  '*': {
    saveFileName: 'oss-registo-uniao',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'Está prestes a enviar um registro no regime União. Ao fazê-lo irá confirmar que não está inscrito no regime da União noutro Estado-Membro.',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submeter',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'Confirmo que tomei conhecimento dos alertas produzidos pelos dados desta declaração.',
    ["modalYesBtn"]: 'Confirmar',
    ["modalNoBtn"]: 'Cancelar',
    ["schemeConditionsTitle"]: 'Condições de acesso',
    ["schemeConditions"]: `
      <p>Para se registar neste regime deverá confirmar que reúne <strong>uma</strong> das seguintes condições:</p>
      <ul>
        <li>É um <strong>sujeito passivo estabelecido na UE</strong> e pretende declarar e pagar o IVA relativamente a prestações de serviços B2C que ocorrem num outro Estado-Membro ou a vendas à distância;</li>
        <li>É um <strong>sujeito passivo não estabelecido na UE</strong> e pretende declarar e pagar o IVA relativamente a vendas à distância intracomunitárias de bens;</li>
        <li>É uma <strong>interface eletrónica</strong> (estabelecida na UE ou fora da UE) que facilita a entrega de bens em vendas à distância intracomunitárias de bens e realiza determinadas entregas internas de bens;</li>
      </ul>
    `
  }
};
